export default "/assets/images/app-update-img-05.187ba3ae722dc76b.png";